import { TASK_STATUSES, type TaskStatus } from '@/shared/types/taskQueue.types';

export const TASK_STATUS_LABELS = {
  proposed: 'Proposed',
  available: 'Available',
  assigned: 'In progress',
  released: 'Handoff',
  completed: 'Completed',
  superseded: 'Superseded',
  archived: 'Archived',
} as const satisfies Record<TaskStatus, string>;

function isTaskStatus(value: string): value is TaskStatus {
  return (TASK_STATUSES as readonly string[]).includes(value);
}

/** Accepts API status strings (Zod enum may infer as `string` on the client DTO). */
export function taskStatusLabel(status: string): string {
  if (isTaskStatus(status)) return TASK_STATUS_LABELS[status];
  return status;
}
